import { AxiosError } from "axios";
import type { ApiError } from "@/types";
import { captureException } from "@/lib/sentry";
import i18n from "@/i18n";

function extractFieldErrors(data: unknown): string | null {
  if (typeof data !== "object" || data === null || Array.isArray(data)) {
    return null;
  }
  const messages: string[] = [];
  for (const value of Object.values(data)) {
    if (Array.isArray(value) && value.every((v) => typeof v === "string")) {
      messages.push(...value);
    }
  }
  return messages.length > 0 ? messages.join(" ") : null;
}

export function handleApiError(error: unknown): ApiError {
  // Capture error with Sentry
  captureException(error);

  if (error instanceof AxiosError) {
    const data = error.response?.data;

    const message =
      data?.message ||
      data?.detail ||
      data?.error ||
      (typeof data === "string" ? data : "") ||
      extractFieldErrors(data) ||
      error.message ||
      i18n.t("errors.generic");

    return {
      message,
      status: error.response?.status,
      errors: data?.errors,
    };
  }

  if (error instanceof Error) {
    return {
      message: error.message,
    };
  }

  return {
    message: i18n.t("errors.unexpected"),
  };
}
